import React, { useState, useLayoutEffect } from 'react';
import { Text, Button, Card  } from '../../Atoms';
import { Col, Row } from 'react-bootstrap';

function getCutProfileNames(props) {
  const currentProfileNames = []
  props.benificiaireList.forEach(element => {
    let currentProfileFirstname = ""
    if (element.value.name.length > 12) {
      const result = element.value.name.match(/.{1,12}/g) ?? [];

      currentProfileFirstname = (result.join(' '));
    } else {
      currentProfileFirstname = (element.value.name)
    }
    let currentProfileLastname = ""
    if (element.value.lastName.length > 12) {
      const result = element.value.lastName.match(/.{1,12}/g) ?? [];

      currentProfileLastname = (result.join(' '));
    } else {
      currentProfileLastname = (element.value.lastName)
    }
    currentProfileNames.push({ name: `${currentProfileFirstname} ${currentProfileLastname}`, value: element.value })

  });
  return (currentProfileNames)
}
function useWindowSize(props) {
  const [profileNames, setProfileNames] = useState(window.innerWidth <= 1400 ? getCutProfileNames(props) : props.benificiaireList);
  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth <= 1400) {
        setProfileNames(getCutProfileNames(props))
      } else {
        setProfileNames(props.benificiaireList)
      }
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, [props.benificiaireList]);
  return profileNames;
}

function TemplateProfileScreen1(props) {
  const profileNames = useWindowSize(props)

  return (
    <div className='template-scroll cartetp-container'>
      <div className='cartetp-header-container'>
        <Text text='Profil' type='h4' />
      </div>
      <div className='profile-title'>
        <Text
          text={
            window.innerWidth <= 768
              ? 'Choissisez un bénéficiaire'
              : 'Choissisez un bénéficiaire pour consulter ses informations.'
          }
          type='h7'
        />
      </div>
      <div className='profile-card-container'>
        <Row>
          {profileNames.map((el, index) => (
            <Col
              className='container-card-profile scale-up-center'
              key={index}
              md={4}
              xs={
                (index + 1) % 3 === 2 &&
                  props.benificiaireList.length === index + 1
                  ? 12
                  : 6
              }
            >
              <Card
                text={el.name}
                size='medium'
                onClick={() => props.handelSelectedProfile(el.value, index)}
              />
            </Col>
          ))}
        </Row>
      </div>
      <div className='profile-btn-add-beneficiaire-container'>
        <Button
          text={
            window.innerWidth <= 768
              ? 'Ajouter des béneficiaires'
              : 'Ajouter un bénéficiaire'
          }
          className='btn-add-beneficiaire-profile'
          onClick={() => props.navigationSteps('ADD_BENEFICIAIRE_STEP1')}
        />
      </div>
    </div>
  );
}

export default TemplateProfileScreen1;
